export default __webpack_public_path__ + "530a055c129ddea2d2c4229bb85c04cc.pdf";